import { render, staticRenderFns } from "./malaria.vue?vue&type=template&id=44c4d5c7&scoped=true"
import script from "./malaria.vue?vue&type=script&lang=js"
export * from "./malaria.vue?vue&type=script&lang=js"
import style0 from "./malaria.vue?vue&type=style&index=0&id=44c4d5c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c4d5c7",
  null
  
)

export default component.exports